import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

const ThankYou = () => {
  useEffect(() => {
    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("event", "conversion", {
        send_to: "AW-17910601966",
        value: 1.0,
        currency: "USD",
      });
    }
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-20">
      <Helmet>
        <title>Thank You | Battle Born Protection Films</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="text-center max-w-xl mx-auto px-4 animate-fade-in">
        <CheckCircle className="w-16 h-16 text-accent mx-auto mb-6" />
        <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">
          Thank You!
        </h1>
        <p className="text-lg text-muted-foreground mb-8">
          Your quote request has been received. Our team will review your details and get back to you within 24 hours.
        </p>
        <Button asChild variant="premium" size="lg">
          <Link to="/">Back to Home</Link>
        </Button>
      </div>
    </div>
  );
};

export default ThankYou;
